module.exports = __webpack_public_path__ + "static/img/kefu.5c641ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kefu.png
// module id = mjJX
// module chunks = 0